class ArcticTestimonials extends HTMLElement {
  connectedCallback() {
    if (this.embla) return;
    if (!window.EmblaCarousel) {
      console.warn('ArcticTestimonials: window.EmblaCarousel not loaded');
      return;
    }

    const viewport = this.querySelector('.testimonials__viewport');
    const dotsContainer = this.querySelector('.testimonials__dots');
    if (!viewport) return;

    const slideNodes = Array.from(viewport.querySelectorAll('.testimonials__slide'));
    if (slideNodes.length === 0) return;

    const options = {
      loop: slideNodes.length > 1,
      align: 'center',
      skipSnaps: false,
      duration: 28,
    };

    const plugins = [];
    const autoplayEnabled =
      this.dataset.autoplay === 'true' &&
      slideNodes.length > 1 &&
      window.EmblaCarouselAutoplay &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (autoplayEnabled) {
      const delay = parseInt(this.dataset.autoplayDelay, 10) || 6000;
      plugins.push(
        window.EmblaCarouselAutoplay({
          delay,
          stopOnInteraction: true,
          stopOnMouseEnter: true,
          stopOnFocusIn: true,
        }),
      );
    }

    this.embla = window.EmblaCarousel(viewport, options, plugins);

    let dotNodes = [];
    if (dotsContainer && slideNodes.length > 1) {
      dotsContainer.innerHTML = this.embla
        .scrollSnapList()
        .map(
          (_, i) =>
            `<button class="testimonials__dot arctic-dot" type="button" aria-label="Go to testimonial ${i + 1}"></button>`,
        )
        .join('');
      dotNodes = Array.from(dotsContainer.querySelectorAll('.testimonials__dot'));
      dotNodes.forEach((dot, i) => {
        dot.addEventListener('click', () => this.embla.scrollTo(i));
      });
    }

    const updateActive = () => {
      const idx = this.embla.selectedScrollSnap();
      slideNodes.forEach((node, i) => {
        node.classList.toggle('is-active', i === idx);
      });
      dotNodes.forEach((node, i) => {
        const isActive = i === idx;

        node.classList.toggle('is-active', isActive);
        node.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    this.embla.on('select', updateActive);
    this.embla.on('reInit', updateActive);
    updateActive();
    this.classList.add('is-ready');
  }

  disconnectedCallback() {
    if (this.embla) {
      this.embla.destroy();
      this.embla = null;
    }
    this.classList.remove('is-ready');
  }
}

if (!customElements.get('arctic-testimonials')) {
  customElements.define('arctic-testimonials', ArcticTestimonials);
}
